import React from "react";
import { useTranslation } from "react-i18next";
import { GalleryVerticalEnd } from "lucide-react";

const NoDataComponent = ({}) => {
  const { t: translate, i18n } = useTranslation();

  return (
    <div className="text-center w-full flex flex-col items-center gap-4">
      <GalleryVerticalEnd />
      <span>{translate("shared.no-data")}</span>
    </div>
  );
};

export default NoDataComponent;
